const env = process.env.REACT_APP_ENV || 'prod'

// const localhost = '192.168.0.16';
const localhost = 'localhost'
const urls = {
    local: {
        baseUrl: `http://${localhost}:8080`,
        socketUrl: `http://${localhost}:6000`,
        fileSystemUrl: 'https://files.alkalmaup.com',
        videoUrl: 'https://videos.alkalmaup.com',
    },
    dev: {
        baseUrl: 'https://api-dev.alkalmaup.com',
        socketUrl: 'https://ws-dev.alkalmaup.com',
        fileSystemUrl: 'https://files.alkalmaup.com',
        videoUrl: 'https://videos.alkalmaup.com',
    },
    prod: {
        baseUrl: 'https://api.alkalmaup.com',
        socketUrl: 'https://ws.alkalmaup.com',
        fileSystemUrl: 'https://files.alkalmaup.com',
        videoUrl: 'https://videos.alkalmaup.com',
    },
    staging: {
        baseUrl: 'https://web-api-staging.alkalmaup.com',
        socketUrl: 'https://ws-dev.alkalmaup.com',
        fileSystemUrl: 'https://files.alkalmaup.com',
        videoUrl: 'https://videos.alkalmaup.com',
    },
}

export const baseUrl = urls[env].baseUrl
export const socketUrl = urls[env].socketUrl
export const fileSystemUrl = urls[env].fileSystemUrl
export const videoUrl = urls[env].videoUrl
